interface TextProps extends React.HTMLAttributes<HTMLParagraphElement> {
	children: React.ReactNode;
	variant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "h7" | "big" | "h8" | "extraBig" | "mediumBig" | "smallBig";
	className?: string;
}

export const TextComponent = ({ children, variant = "h3", className = "", ...props }: TextProps) => {
	let baseClass = "";

	switch (variant) {
		case "extraBig":
			baseClass = "text-6xl md:text-7xl lg:text-8xl"; /* 60px */
			break;
		case "big":
			baseClass = "text-4xl md:text-6xl"; /* 45px */
			break;
		case "mediumBig":
			baseClass = "text-4xl md:text-5xl"; /* 45px */
			break;
		case "smallBig":
			baseClass = "text-3xl md:text-4xl"; /* 45px */
			break;
		case "h1":
			baseClass = "text-2xl md:text-3xl"; /* 30px */
			break;
		case "h2":
			baseClass = "text-xl md:text-2xl"; /* 24px */
			break;
		case "h3":
			baseClass = "text-lg md:text-xl"; /* 20px */
			break;
		case "h4":
			baseClass = "text-base md:text-lg"; /* 18px */
			break;
		case "h5":
			baseClass = "text-sm md:text-base"; /* 16px */
			break;
		case "h6":
			baseClass = "text-xs md:text-sm"; /* 14px */
			break;
		case "h7":
			baseClass = "text-[10px] md:text-xs"; /* 12px */
			break;
		case "h8":
			baseClass = "text-[8px] md:text-[10px]"; /* 12px */
			break;
		default:
			baseClass = "text-base sm:text-lg md:text-xl lg:text-2xl xl:text-3xl";
	}

	return (
		<p
			className={`${baseClass} ${className}`}
			{...props}
		>
			{children}
		</p>
	);
};
